import { createAction } from 'redux-actions';

import { SET_LASER_OUTPUT_QUALITY } from '@/constants';
import { createSnapshotThunk } from '@/actions';

const setLaserOutputQuality = value => createAction(SET_LASER_OUTPUT_QUALITY, () => value)();

export const setLaserOutputQualityThunk = (value, isUndoable = true) => (dispatch, getState) => {
  dispatch(createSnapshotThunk({ isUndoable }));
  dispatch(setLaserOutputQuality(value));
};
